var _image;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAHYAAAB2AH6XKZyAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAXNJREFUeJzt2r1qFGEUBuBndlnEIuoFZAsra7HxBiJ4AcHSH7DyGrwSwc5CCdhoIZpeC63EG0jnz5KMFil012JYXQsLkczZ7LwPHIbp3hmGj2/O+YiIiIgYqGblegM72KqL04uv2Mdj/IAJnmMxsNrHZIz7uPs/r/SUuojvDQ6wXRymykGDY5ypTlLkeIQP1SkKvR9jht3qJAUWuLO8uYVD9StzX3WIm/zeB8B5XMW5f32Vp8wRXqOtDhIRERER62CKPd32sHqfftLV4ikurT78lzUI1nfNMB3jIa4YnrPYbnSfxKZ3gv+mHVUnKLYY6drDQ/WCbjWcqV+U+q7PVrrhUzzRdUuqg510HemmQkMdBUREREQE/hyOXtANRzf917jFG92E+JfbhvEfsKxvuLd8+B3M1yBU3zXH9QbvcNkwvc0hKXyqTlHo4wiPqlMUekDXHn6mflHqu15isnpYehfXbP4hqRavdC3AeXGWiIiIiDo/AWYdSHvD8tX2AAAAAElFTkSuQmCC",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    preserveAspectRatio: "xMidYMid meet"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.198ef373f0fe2e9b87db742d8776f9fa.svg";
export { ForwardRef as ReactComponent };